
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sms-messaging-consent",
      function () {
        return require("private-next-pages/sms-messaging-consent.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sms-messaging-consent"])
      });
    }
  